
    <ng-container #entryPoint></ng-container>
    <fl-modal></fl-modal>
  


// WEBPACK FOOTER //
// ./src/compat/compat.component.ts.CompatComponent.html